import { createContext, useContext, useEffect, useState } from "react";
import { getAllCompanyAdmin } from "../service/companyManagement";

const CompanyAdminContext = createContext({
  data: [],
  setData: () => [],
  refreshData: async () => {},
  calculateCounts: () => {},
  counts: {
    totalUserLimit: 0,
    totalUserOccupied: 0,
    totalJobs: 0,
    totalPaidSubscriptionPayment: 0,
    totalPendingSubscriptionPayment: 0,
    totalSubscriptionPayment: 0,
  },
});

export default function CompanyAdminProvider({ children }) {
  const [data, setData] = useState([]);
  const [counts, setCounts] = useState({
    totalUserLimit: 0,
    totalUserOccupied: 0,
    totalJobs: 0,
    totalPaidSubscriptionPayment: 0,
    totalPendingSubscriptionPayment: 0,
    totalSubscriptionPayment: 0,
  });

  const getAllCompanyData = async () => {
    const res = await getAllCompanyAdmin();

    if (!res) return;

    const formattedData = res?.data.map((admin) => ({
      ...admin,
      title: `${admin.companyName}`,
    }));

    setData(formattedData);

    calculateCounts(formattedData);
  };

  const calculateCounts = (visibleData) => {
    const totalUserLimit = visibleData.reduce(
      (acc, cValue) => acc + cValue["userLimit"],
      0
    );
    const totalUserOccupied = visibleData.reduce(
      (acc, cValue) => acc + cValue["userOccupied"],
      0
    );
    const totalJobs = visibleData.reduce(
      (acc, cValue) => acc + cValue["jobCount"],
      0
    );
    const totalSubscriptionPayment = visibleData.reduce(
      (acc, cValue) => acc + cValue["subscriptionPayment"],
      0
    );
    const totalPaidSubscriptionPayment = visibleData.reduce(
      (acc, data) =>
        data.paymentStatus === true ? acc + data.subscriptionPayment : acc,
      0
    );
    const totalPendingSubscriptionPayment = visibleData.reduce(
      (acc, data) =>
        data.paymentStatus === false ? acc + data.subscriptionPayment : acc,
      0
    );
    setCounts({
      totalUserLimit,
      totalUserOccupied,
      totalJobs,
      totalPaidSubscriptionPayment,
      totalPendingSubscriptionPayment,
      totalSubscriptionPayment,
    });
  };

  useEffect(() => {
    getAllCompanyData();
  }, []);

  return (
    <CompanyAdminContext.Provider
      value={{
        data,
        setData,
        refreshData: getAllCompanyData,
        calculateCounts,
        counts,
      }}
    >
      {children}
    </CompanyAdminContext.Provider>
  );
}

export const useCompanyAdmin = () => useContext(CompanyAdminContext);
